import { jsxs as s, jsx as i, Fragment as de } from "react/jsx-runtime";
import { useMemo as ce } from "react";
import { a as n, i as he } from "../../core-DVmjA3_O.js";
import { _ as x } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import le from "../BlockView/index.js";
import ge from "../DefaultMessage/index.js";
import fe from "../Description/index.js";
import me from "../Heading/index.js";
import F from "../InlineView/index.js";
import d from "../ListView/index.js";
import pe from "../../hooks/useSpacingToken.js";
import { getSpacingValue as _e, paddingSpacings as ue } from "../../utils/style.js";
import '../../index19.css';const Ce = "_container_1wgmw_1", ve = "_with-centered-content_1wgmw_2", ke = "_with-fixed-height_1wgmw_8", Oe = "_with-shadow_1wgmw_13", Be = "_with-background_1wgmw_17", Se = "_with-border_1wgmw_22", be = "_with-dark-background_1wgmw_27", He = "_form-variant_1wgmw_32", Pe = "_before-container_1wgmw_33", De = "_content_1wgmw_38", ye = "_pending-overlaid_1wgmw_46", Me = "_message_1wgmw_51", Ne = "_with-overflow_1wgmw_56", xe = "_without-padding-overflow_1wgmw_57", Fe = "_with-padding-overflow_1wgmw_61", Ie = "_overflow-container_1wgmw_64", Ve = "_filters_1wgmw_71", We = "_with-content-well_1wgmw_76", e = {
  container: Ce,
  withCenteredContent: ve,
  withFixedHeight: ke,
  withShadow: Oe,
  withBackground: Be,
  withBorder: Se,
  withDarkBackground: be,
  formVariant: He,
  beforeContainer: Pe,
  content: De,
  pendingOverlaid: ye,
  message: Me,
  withOverflow: Ne,
  withoutPaddingOverflow: xe,
  withPaddingOverflow: Fe,
  overflowContainer: Ie,
  filters: Ve,
  withContentWell: We
};
function Ue(I) {
  const {
    className: V,
    elementRef: W,
    heading: v,
    withEllipsizedHeading: A,
    headingLevel: c = 3,
    headerIcons: k,
    headerActions: h,
    headerDescription: l,
    withHeaderBorder: L,
    withCenteredHeading: j,
    withCenteredHeaderDescription: z,
    withoutWrapInHeader: O,
    withLargeBreakpointInHeader: B,
    variant: g = "default",
    filters: f,
    footerIcons: S,
    footer: b,
    footerActions: H,
    withFooterBorder: E,
    withoutWrapInFooter: R,
    children: m,
    withContentOverflow: a,
    withContentWell: P,
    empty: p = !1,
    filtered: D = !1,
    pending: _ = !1,
    overlayPending: u,
    errored: C = !1,
    emptyMessage: $,
    filteredEmptyMessage: G,
    pendingMessage: T,
    errorMessage: q,
    withoutMessageIcon: J,
    withCompactMessage: K,
    withoutMessage: Q = !1,
    withBackground: U,
    withDarkBackground: X,
    withShadow: Y,
    withPadding: w,
    withBorder: Z,
    withFixedHeight: ee,
    spacing: t,
    spacingOffset: o = 0,
    withoutSpacingOpticalCorrection: r,
    withCenteredContent: te,
    withOverflow: oe,
    ...ie
  } = I, y = n(v) || n(k) || n(h), ne = y || n(l), re = n(b) || n(S) || n(H), ae = pe({
    spacing: t,
    offset: o,
    modes: ue,
    withoutOpticalCorrection: r
  }), M = _e(t, o), we = a && w ? /* @__PURE__ */ i(
    "div",
    {
      className: e.overflowContainer,
      style: {
        padding: `0 ${M}`,
        margin: `0 calc(-1 * ${M})`
      },
      children: m
    }
  ) : m, N = (m || p || _ || C || D) && /* @__PURE__ */ s(de, { children: [
    !Q && /* @__PURE__ */ i(
      ge,
      {
        className: e.message,
        pending: _,
        filtered: D,
        errored: C,
        empty: p,
        overlayPending: u,
        emptyMessage: $,
        filteredEmptyMessage: G,
        pendingMessage: T,
        errorMessage: q,
        withoutIcon: J,
        compact: K
      }
    ),
    !p && !C && (!_ || u) && we
  ] }), se = ce(() => O ? "none" : c > 3 ? "sm" : B ? "lg" : "md", [c, B, O]);
  return /* @__PURE__ */ s(
    le,
    {
      ...ie,
      elementRef: W,
      className: x(
        e.container,
        U && e.withBackground,
        X && e.withDarkBackground,
        Y && e.withShadow,
        P && e.withContentWell,
        ee && e.withFixedHeight,
        te && e.withCenteredContent,
        Z && e.withBorder,
        g === "form" && e.formVariant,
        V
      ),
      spacing: t,
      spacingOffset: o,
      withoutSpacingOpticalCorrection: r,
      withPadding: w,
      beforeContainerClassName: e.beforeContainer,
      before: ne && /* @__PURE__ */ s(
        d,
        {
          spacing: t,
          spacingOffset: o,
          layout: "block",
          withSpacingOpticalCorrection: !0,
          withBackground: g === "form",
          withPadding: g === "form",
          children: [
            y && /* @__PURE__ */ i(
              F,
              {
                spacing: t,
                spacingOffset: o - 1,
                withoutSpacingOpticalCorrection: r,
                wrapBreakpoint: se,
                before: k,
                after: h && /* @__PURE__ */ i(
                  d,
                  {
                    spacing: t,
                    spacingOffset: o - 1,
                    withSpacingOpticalCorrection: !r,
                    children: h
                  }
                ),
                children: /* @__PURE__ */ i(
                  me,
                  {
                    level: c,
                    ellipsize: A,
                    spacing: t,
                    centerAligned: j,
                    children: v
                  }
                )
              }
            ),
            l && /* @__PURE__ */ i(fe, { withCenteredContent: z, children: l })
          ]
        }
      ),
      after: re && /* @__PURE__ */ i(
        F,
        {
          spacing: t,
          spacingOffset: o,
          withoutSpacingOpticalCorrection: r,
          before: S,
          after: H,
          wrapBreakpoint: R ? "none" : "lg",
          children: b
        }
      ),
      withBeforeSeparator: L,
      withAfterSeparator: E,
      childrenContainerClassName: x(
        e.content,
        u && e.pendingOverlaid,
        a && e.withOverflow,
        w && a && e.withPaddingOverflow,
        !w && a && e.withoutPaddingOverflow,
        P && ae
      ),
      withOverflow: oe,
      children: [
        n(f) && /* @__PURE__ */ s(
          d,
          {
            layout: "block",
            spacing: t,
            spacingOffset: o,
            children: [
              /* @__PURE__ */ i(
                d,
                {
                  gridContentClassName: e.filters,
                  layout: "grid",
                  numPreferredGridColumns: 6,
                  spacing: t,
                  spacingOffset: o - 1,
                  children: f
                }
              ),
              N
            ]
          }
        ),
        he(f) && N
      ]
    }
  );
}
export {
  Ue as default
};
